import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner'
import { NoActiveGameUI } from '../NoActiveGameUI/NoActiveGameUI'
import { useTheme } from '../../../contexts/ThemeContext'
import type { RoomViewVMNoActiveGameVM } from '../../../deps/ui/playAreaVM/playAreaVM.types'

interface PlayAreaUIProps {
  isLoading: boolean
  isAutoStarting: boolean
  autoStartGameName: string | null
  hasActiveGame: boolean
  isStartingGameSetup: boolean
  noActiveGame: RoomViewVMNoActiveGameVM
  children?: React.ReactNode
}

export function PlayAreaUI({
  isLoading,
  isAutoStarting,
  autoStartGameName,
  hasActiveGame,
  isStartingGameSetup,
  noActiveGame,
  children
}: PlayAreaUIProps) {
  // Get app background color from theme
  const { getAppColor } = useTheme()
  const appColorShades = getAppColor()

  if (isLoading) {
    return <LoadingSpinner message="Loading room state..." />
  }

  if (isAutoStarting) {
    return (
      <LoadingSpinner
        message={
          autoStartGameName && hasActiveGame
            ? `Ending current game and starting ${autoStartGameName}...`
            : `Starting ${autoStartGameName || 'game'}...`
        }
      />
    )
  }

  if (!hasActiveGame) {
    if (isStartingGameSetup) {
      // While starting a game (setup dialogs), don't show the game list underneath.
      return <div style={{ backgroundColor: appColorShades.background, width: '100%', height: '100%' }} />
    }
    return (
      <div style={{ backgroundColor: appColorShades.background, width: '100%', height: '100%' }}>
        <NoActiveGameUI noActiveGame={noActiveGame} />
      </div>
    )
  }

  return <>{children}</>
}

